import { Modal, Input, message } from "antd";
import { useState } from "react";
import * as reprocesoService from "../../../services/participantes/reprocesoService";

const { TextArea } = Input;

export function ReprocesoModal({
  open,
  onClose,
  participante
}) {

  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {

    if (!participante?.id) return;

    try {
      setLoading(true);

      message.loading("Reprocesando...", 0);

      const res = await reprocesoService.reprocesarParticipante(
        participante.id,
        observacion
      );

      message.destroy();

      if (res?.ok) {
        message.success("Reproceso realizado correctamente");
        onClose(true);
      } else {
        message.warning(res?.message || "No se pudo reprocesar");
      }

    } catch (err) {

      console.error("Error reprocesando:", err);
      message.destroy();
      message.error("Error realizando reproceso");

    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Reprocesar participante"
      okText="Reprocesar"
      cancelText="Cancelar"
      okType="danger"
      confirmLoading={loading}
      onOk={handleConfirm}
      onCancel={() => onClose(false)}
    >

      <p>
        ⚠️ Esta acción eliminará todo el historial de llamadas del participante.
      </p>

      <p>
        <b>{participante?.nombres} {participante?.apellidos}</b>
      </p>

      <TextArea
        rows={4}
        placeholder="Observación (opcional)"
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        maxLength={500}
        showCount
      />

    </Modal>
  );
}